var link_viewer_wrapper_default = {
  "anchor": "qjhGZ",
  "link": "ulp91"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
